import ImageZoom from 'js-image-zoom';

document.addEventListener('DOMContentLoaded', () => {
  const imgSlides = [...document.querySelectorAll('.single-product__gallery-zoom')] as HTMLElement[];
  const thumbs = [...document.querySelectorAll('.js-product-gallery-thumb')];
  // console.debug({ imgSlides, images, thumbs });

  let imgZoom: ImageZoom | null = null;

  function killZoom() {
    if (imgZoom) {
      imgZoom.kill();
      imgZoom = null;
    }
  }

  // Add click listeners
  imgSlides.forEach((slide) => {
    slide.addEventListener('click', () => {
      // Kill or create zoom on click
      if (imgZoom) {
        killZoom();
      } else {
        imgZoom = new ImageZoom(slide, {
          fillContainer: true,
          zoomPosition: 'original',
        });
      }
    });
  });

  // Kill ImageZoom on thumbnail click
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => killZoom());
  });
});
